var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-form",
    {
      attrs: { size: "small" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("sui-header", { tag: "h3" }, [
        _vm._v("Exhibit B: Investor(s) Profile "),
      ]),
      _vm.user.profile.profile_type === 2
        ? _c(
            "sui-grid",
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    [
                      _c(
                        "sui-form-field",
                        { attrs: { width: 4 } },
                        [
                          _c("label", [_vm._v("Client")]),
                          _c("sui-dropdown", {
                            attrs: {
                              selection: "",
                              floating: "",
                              direction: "downward",
                              placeholder: "Client",
                              options: _vm.clients,
                            },
                            model: {
                              value: _vm.email,
                              callback: function ($$v) {
                                _vm.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                { attrs: { width: 8 } },
                [
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "1. Plan to begin taking money from investments in:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-relation-time-horizon" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Under 1 year",
                                radio: "",
                                value: "Under 1 year",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "1-2 years",
                                radio: "",
                                value: "1-2 years",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "3-5 years",
                                radio: "",
                                value: "3-5 years",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "6-10 years",
                                radio: "",
                                value: "6-10 years",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "11-20 years",
                                radio: "",
                                value: "11-20 years",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Relationship_Time_Horizon__c
                                    .$error,
                              },
                              attrs: {
                                label: "Over 20 years",
                                radio: "",
                                value: "Over 20 years",
                              },
                              model: {
                                value: _vm.form.IP_Relationship_Time_Horizon__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Time_Horizon__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Time_Horizon__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Relationship_Time_Horizon__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "2. After beginning to take money from investments, plan to take withdrawals over a period of:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-relationship-withdrawal-period" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Under 5 years",
                                radio: "",
                                value: "Under 5 years",
                              },
                              model: {
                                value:
                                  _vm.form.IP_Relationship_Withdrawal_Period__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Withdrawal_Period__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Withdrawal_Period__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "5-10 years",
                                radio: "",
                                value: "5-10 years",
                              },
                              model: {
                                value:
                                  _vm.form.IP_Relationship_Withdrawal_Period__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Withdrawal_Period__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Withdrawal_Period__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "10-20 years",
                                radio: "",
                                value: "10-20 years",
                              },
                              model: {
                                value:
                                  _vm.form.IP_Relationship_Withdrawal_Period__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Withdrawal_Period__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Withdrawal_Period__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form
                                    .IP_Relationship_Withdrawal_Period__c
                                    .$error,
                              },
                              attrs: {
                                label: "Over 20 years",
                                radio: "",
                                value: "Over 20 years",
                              },
                              model: {
                                value:
                                  _vm.form.IP_Relationship_Withdrawal_Period__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Relationship_Withdrawal_Period__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Relationship_Withdrawal_Period__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Relationship_Withdrawal_Period__c
                          .required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "3. Current plan is to withdraw this percentage annually from the portfolio:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-percentage-withdrawal" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: { label: "0%", radio: "", value: "0%" },
                              model: {
                                value: _vm.form.IP_Percentage_Withdrawal__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percentage_Withdrawal__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percentage_Withdrawal__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "1-4%",
                                radio: "",
                                value: "1-4%",
                              },
                              model: {
                                value: _vm.form.IP_Percentage_Withdrawal__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percentage_Withdrawal__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percentage_Withdrawal__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "5-10%",
                                radio: "",
                                value: "5-10%",
                              },
                              model: {
                                value: _vm.form.IP_Percentage_Withdrawal__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percentage_Withdrawal__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percentage_Withdrawal__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Percentage_Withdrawal__c
                                    .$error,
                              },
                              attrs: {
                                label: "Over 10%",
                                radio: "",
                                value: "Over 10%",
                              },
                              model: {
                                value: _vm.form.IP_Percentage_Withdrawal__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percentage_Withdrawal__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percentage_Withdrawal__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Percentage_Withdrawal__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "4. Risk tolerance, defined as willingness to accept a potential loss for a greater long-term gain, is:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-risk-tolerance" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label:
                                  "Low (Loss of 5% for even greater long-term gain)",
                                radio: "",
                                value:
                                  "Low (Loss of 5% for even greater long-term gain)",
                              },
                              model: {
                                value: _vm.form.IP_Risk_Tolerance__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Risk_Tolerance__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Risk_Tolerance__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label:
                                  "Moderate (Loss of 15% for even greater long-term gain)",
                                radio: "",
                                value:
                                  "Moderate (Loss of 15% for even greater long-term gain)",
                              },
                              model: {
                                value: _vm.form.IP_Risk_Tolerance__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Risk_Tolerance__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Risk_Tolerance__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Risk_Tolerance__c.$error,
                              },
                              attrs: {
                                label:
                                  "High (Loss of 30% for even greater long-term gain)",
                                radio: "",
                                value:
                                  "High (Loss of 30% for even greater long-term gain)",
                              },
                              model: {
                                value: _vm.form.IP_Risk_Tolerance__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Risk_Tolerance__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Risk_Tolerance__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Risk_Tolerance__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "5. Current sources of income (such as salary, Social Security, pension) are expected to be:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-source-of-income" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Very unstable",
                                radio: "",
                                value: "Very unstable",
                              },
                              model: {
                                value: _vm.form.IP_Sources_of_Income__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Sources_of_Income__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Sources_of_Income__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Unstable",
                                radio: "",
                                value: "Unstable",
                              },
                              model: {
                                value: _vm.form.IP_Sources_of_Income__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Sources_of_Income__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Sources_of_Income__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Somewhat stable",
                                radio: "",
                                value: "Somewhat stable",
                              },
                              model: {
                                value: _vm.form.IP_Sources_of_Income__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Sources_of_Income__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Sources_of_Income__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Stable",
                                radio: "",
                                value: "Stable",
                              },
                              model: {
                                value: _vm.form.IP_Sources_of_Income__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Sources_of_Income__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Sources_of_Income__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Sources_of_Income__c.$error,
                              },
                              attrs: {
                                label: "Very stable",
                                radio: "",
                                value: "Very stable",
                              },
                              model: {
                                value: _vm.form.IP_Sources_of_Income__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Sources_of_Income__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Sources_of_Income__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Sources_of_Income__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "sui-grid-column",
                { attrs: { width: 8 } },
                [
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "6. This investment portfolio accounts for what percent of personal net worth:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-percent-of-wealth" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "0%-25%",
                                radio: "",
                                value: "0-25%",
                              },
                              model: {
                                value: _vm.form.IP_Percent_of_Wealth__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percent_of_Wealth__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percent_of_Wealth__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "25%-50%",
                                radio: "",
                                value: "25-50%",
                              },
                              model: {
                                value: _vm.form.IP_Percent_of_Wealth__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percent_of_Wealth__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percent_of_Wealth__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "50%-75%",
                                radio: "",
                                value: "50-75%",
                              },
                              model: {
                                value: _vm.form.IP_Percent_of_Wealth__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percent_of_Wealth__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percent_of_Wealth__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Percent_of_Wealth__c.$error,
                              },
                              attrs: {
                                label: "75%-100%",
                                radio: "",
                                value: "75-100%",
                              },
                              model: {
                                value: _vm.form.IP_Percent_of_Wealth__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Percent_of_Wealth__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Percent_of_Wealth__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Percent_of_Wealth__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "7. Level of investment experience in stock and bond funds would be described as:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-investment-experience" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Inexperienced",
                                radio: "",
                                value: "Inexperienced",
                              },
                              model: {
                                value: _vm.form.IP_Investment_Experience__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Investment_Experience__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Investment_Experience__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Somewhat experienced",
                                radio: "",
                                value: "Somewhat experienced",
                              },
                              model: {
                                value: _vm.form.IP_Investment_Experience__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Investment_Experience__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Investment_Experience__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Experienced",
                                radio: "",
                                value: "Experienced",
                              },
                              model: {
                                value: _vm.form.IP_Investment_Experience__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Investment_Experience__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Investment_Experience__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Investment_Experience__c
                                    .$error,
                              },
                              attrs: {
                                label: "Very experienced",
                                radio: "",
                                value: "Very experienced",
                              },
                              model: {
                                value: _vm.form.IP_Investment_Experience__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Investment_Experience__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Investment_Experience__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Investment_Experience__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "8. Desire to invest primarily in socially responsible investment funds:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-socially-responsible-investing" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: { label: "Yes", radio: "", value: "Yes" },
                              model: {
                                value:
                                  _vm.form.IP_Socially_Responsible_Investing__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Socially_Responsible_Investing__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Socially_Responsible_Investing__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form
                                    .IP_Socially_Responsible_Investing__c
                                    .$error,
                              },
                              attrs: { label: "No", radio: "", value: "No" },
                              model: {
                                value:
                                  _vm.form.IP_Socially_Responsible_Investing__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Socially_Responsible_Investing__c",
                                    $$v
                                  )
                                },
                                expression:
                                  "form.IP_Socially_Responsible_Investing__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Socially_Responsible_Investing__c
                          .required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("sui-form-fields", { attrs: { grouped: "" } }, [
                    _c("label", [
                      _vm._v(
                        "9. The new investment objective and target mix of stocks versus bond investments is:"
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "ip-asset-allocation" },
                      [
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Conservative (0% Stocks / 100% Bonds)",
                                radio: "",
                                value: "Conservative (0% Stocks / 100% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Conservative (10% Stocks / 90% Bonds)",
                                radio: "",
                                value: "Conservative (10% Stocks / 90% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Conservative (20% Stocks / 80% Bonds)",
                                radio: "",
                                value: "Conservative (20% Stocks / 80% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Conservative (30% Stocks / 70% Bonds)",
                                radio: "",
                                value: "Conservative (30% Stocks / 70% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Balanced (40% Stocks / 60% Bonds)",
                                radio: "",
                                value: "Balanced (40% Stocks / 60% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Balanced (50% Stocks / 50% Bonds)",
                                radio: "",
                                value: "Balanced (50% Stocks / 50% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Balanced (60% Stocks / 40% Bonds)",
                                radio: "",
                                value: "Balanced (60% Stocks / 40% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Growth (70% Stocks / 30% Bonds)",
                                radio: "",
                                value: "Growth (70% Stocks / 30% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Growth (80% Stocks / 20% Bonds)",
                                radio: "",
                                value: "Growth (80% Stocks / 20% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              attrs: {
                                label: "Growth (90% Stocks / 10% Bonds)",
                                radio: "",
                                value: "Growth (90% Stocks / 10% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "sui-form-field",
                          [
                            _c("sui-checkbox", {
                              class: {
                                "is-invalid":
                                  _vm.submitted &&
                                  _vm.$v.form.IP_Asset_Allocation__c.$error,
                              },
                              attrs: {
                                label: "Growth (100% Stocks / 0% Bonds)",
                                radio: "",
                                value: "Growth (100% Stocks / 0% Bonds)",
                              },
                              model: {
                                value: _vm.form.IP_Asset_Allocation__c,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "IP_Asset_Allocation__c",
                                    $$v
                                  )
                                },
                                expression: "form.IP_Asset_Allocation__c",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.submitted &&
                        !_vm.$v.form.IP_Asset_Allocation__c.required
                          ? _c("div", { staticClass: "invalid-feedback" }, [
                              _vm._v(" Please select an option "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                [
                  _c("InvestorProfileNote", {
                    attrs: { "profile-type": _vm.user.profile.profile_type },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "sui-grid-row",
            [
              _c("sui-grid-column", [
                _c(
                  "div",
                  [
                    _c("sui-button", {
                      attrs: {
                        type: "button",
                        size: "small",
                        content: "Undo",
                        icon: "undo",
                      },
                      on: { click: _vm.handleUndo },
                    }),
                    _c("sui-button", {
                      attrs: { primary: "", size: "small", content: "Save" },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }